import React, { useState, useEffect } from 'react';
import './FormatTransaction.css';

const FormatTransaction = ({ show, onClose, apply }) => {
    const [formatTransaction, setFormatTransaction] = useState(0);
    const [formatTransactionDisplay, setFormatTransactionDisplay] = useState('[Auto]');
    const [options, setOptions] = useState([]);
    const [showLayout, setShowLayout] = useState(false);
    const [prefix, setPrefix] = useState('');
    const [number, setNumber] = useState('');
    const [suffix, setSuffix] = useState('');
    const [startNumber, setStartNumber] = useState('');
    const [textButton, setTextButton] = useState('Gunakan');

    // Dummy response data
    const dummyResponse = [
        { id: 1, param_1: 'INV', param_2: '/001/', status: true },
        { id: 2, param_1: 'DEP', param_2: '/2025/', status: false },
        { id: 3, param_1: 'TRX', param_2: '/100/', status: false },
    ];

    useEffect(() => {
        // Simulate fetching data (use dummyResponse for now)
        setOptions([{ id: 0, param_1: '[Auto]', param_2: '', status: true }, ...dummyResponse]);
        setStartNumber(1);
    }, []);

    const handleOptionChange = (e) => {
        const selectedValue = parseInt(e.target.value, 10);
        const selectedText = e.target.options[e.target.selectedIndex].text;

        setFormatTransaction(selectedValue);
        setFormatTransactionDisplay(selectedText);

        if (selectedValue === 0) {
            setTextButton("Gunakan");
            setPrefix('');
            setNumber('');
            setSuffix('');
            setShowLayout(false);
        } else if (selectedValue === -1) {
            setTextButton("Simpan");
            setShowLayout(true); // Show custom layout for new format
        } else {
            setTextButton("Gunakan");
            setShowLayout(false); // Hide layout and use selected format
            const selectedOption = options.find((option) => option.id === selectedValue);
            setPrefix(selectedOption.param_1);
            setNumber(selectedOption.param_2);
            setSuffix('');
        }
    };

    const handleSave = () => {
        apply(`${prefix}${number}${suffix}${startNumber}`)
        onClose();
    };

    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h4>Nomor Transaksi</h4>
                    <button className="close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                        <label htmlFor="format">Format</label>
                        <select id="format" value={formatTransaction} onChange={handleOptionChange}>
                            <option value={-1}>+Tambah Baru</option>
                            {options.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.param_1}{option.param_2}
                                </option>
                            ))}
                        </select>
                    </div>
                    {showLayout && (
                        <>
                            <div className="form-group row">
                                <input
                                    type="text"
                                    placeholder="Prefix"
                                    value={prefix}
                                    onChange={(e) => setPrefix(e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder="Nomor"
                                    value={number}
                                    onChange={(e) => setNumber(e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder="Suffix"
                                    value={suffix}
                                    onChange={(e) => setSuffix(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="start-number">Mulai Dari Nomor</label>
                                <input
                                    id="start-number"
                                    type="number"
                                    placeholder="1001"
                                    value={startNumber}
                                    onChange={(e) => setStartNumber(e.target.value)}
                                />
                                <small>*Nomor transaksi akan bertambah secara otomatis</small>
                            </div>
                        </>
                    )}
                </div>
                <div className="modal-footer">
                    <button className="save-button" onClick={handleSave}>
                        {textButton}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FormatTransaction;
